import React, { Component } from "react";

export default class WorkspaceModalError extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false };
    }
  
    componentDidCatch(error, info) {
      this.setState({ hasError: true });
    }
  
    render() {
      if (this.state.hasError) {
        // You can render any custom fallback UI
        return (
        <div style = {{height:"17.25rem", padding:"1rem", display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column"}} className="workspace-new-card-modal">
            <div style={{fontSize:"5rem"}} class="material-icons">error_outline</div>
            <div style={{fontSize:"1rem"}}>There was an error while creating/editing this item.</div>
        </div>
        ) //
      }
      return this.props.children;
    }
  }